import { NotificationProvider } from "notification";
import ContainerProvider from "./Containers";
import UserAuth from "./UserAuth";
import UserMenu from "./UserMenu";

export default function ContextContainer({ children }) {
  return (
    <ContainerProvider>
      <UserMenu>
        <UserAuth>
          <NotificationProvider>{children}</NotificationProvider>
        </UserAuth>
      </UserMenu>
    </ContainerProvider>
  );
}
